// src/layouts/Root.jsx
import React from "react";
import TopNavLayout from "../components/Sidebar";

const Root = ({ children }) => {
  return (
    <>
      <TopNavLayout />

      <div className="mx-auto w-full px-2 sm:px-4 lg:px-6 pt-28 pb-10">
        {children}
      </div>
    </>
  );
};

export default Root;
